import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Get from "../services/Get";
import { Button, Card, Col, message, Row, Select, Spin } from "antd";
import logo from "../assets/images/logo.png";
import { PhoneFilled } from "@ant-design/icons";
import Post from "../services/Post";

const { Option } = Select;

const VehicleScan = () => {
  const { qr_no } = useParams();
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [info, setInfo] = useState({});
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const getUserData = () => {
    setLoading(true);
    Get.ScanQr(qr_no)
      .then((res) => {
        if (res.errorMsg) {
          message.error(res.errorMsg);
        }
        if (res.data) {
          setInfo(res.data);
        }
      })
      .catch((error) => {
        message.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getTemplates = () => {
    setLoading(true);
    Get.MessageTemplates()
      .then((res) => {
        if (res.error) {
          message.error(res.error);
        }
        if (res.data) {
          setTemplates(res.data);
        }
      })
      .catch((error) => {
        message.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const assignNumber = (number) => {
    setProcessing(true);
    Post.assignNumber({ mobile: number })
      .then((res) => {
        if (res.error) {
          message.error(res.error);
        }
        if (res.number) {
          window.location.href = `tel:${res.number}`;
        }
      })
      .catch((error) => {
        message.error(error);
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  const sendMessage = () => {
    if (!selectedTemplate) {
      message.warning("Please select a template before sending.");
      return;
    }

    Post.SendMessage({ message: selectedTemplate, qr_no: info.vehicle?.reg_no })
      .then((res) => {
        if (res.error) {
          message.error(res.error);
        } else {
          message.success("Message sent successfully!");
        }
      })
      .catch((error) => {
        message.error(error);
      });
  };

  useEffect(() => {
    getUserData();
    getTemplates();
  }, []);

  return (
    <div className="layout-content" style={{ padding: "20px" }}>
      <Row gutter={[24, 24]} justify="center" align="middle" style={{ minHeight: "100vh" }}>
        <Col xs={24} sm={20} md={16} lg={12} xl={8}>
          <Card
            title="Owner Details"
            bordered={false}
            style={{ maxWidth: "90vw", padding: 20, borderRadius: 12, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}
            headStyle={{ background: "#a6cc43", color: "#fff", borderRadius: "12px 12px 0 0", textAlign: "center" }}
          >
            {loading ? (
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <Spin size="large" />
              </div>
            ) : (
              <>
                <Row style={{ marginBottom: 24 }} align="middle" gutter={[16, 16]}>
                  <Col xs={24} sm={16}>
                    <div>
                      <p><strong>Name:</strong> {info.user?.name || "N/A"}</p>
                      <p><strong>Vehicle No:</strong> {info.vehicle?.reg_no || "N/A"}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={8} style={{ textAlign: "center" }}>
                    <img src={logo} alt="Vehicle Logo" style={{ height: 100, padding: 5, borderRadius: 8, maxWidth: "100%" }} />
                  </Col>
                </Row>

                <Row style={{ marginBottom: 16 }}>
                  <Col span={24}>
                    <Select
                      placeholder="Select a Template"
                      style={{ width: "100%" }}
                      onChange={(value) => setSelectedTemplate(value)}
                    >
                      {templates.map((template) => (
                        <Option key={template.id} value={template.content}>
                          {template.content}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={24} md={12} className="mobile-call-btn">
                    <Button
                      type="primary"
                      block
                      loading={processing}
                      onClick={() => assignNumber(info.user?.mobile)}
                      className="form-btn"
                    >
                      <PhoneFilled /> Connect on Call
                    </Button>
                  </Col>
                  <Col span={24} md={12}>
                    <Button
                      type="default"
                      block
                      onClick={sendMessage}
                      style={{color: '#a6cc43', borderColor: '#a6cc43'}}
                    >
                      Send Message
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default VehicleScan;